import React from 'react';
import CCMRSSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import CategoryScreen from '../../../components/categoryScreen/index';
import CategoryScreenBackground from '../../../images/ComponentImages/categoryScreenBackground.png';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 3 - 4 Sets'
				isNumbered={true}
				rounds={[
					[
						{
							header: 'Type',
							value: 'Alpha',
						},
						{
							header: 'C.C.M.R’s',
							value: 'DEADLIFTS',
						},
						{
							header: 'REPS/Min',
							value: '3-6',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'HEAVY',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
